
export function formatTextToParagraphs(text) {
    return text
        .split(/\r?\n+/)
        .filter(paragraph => paragraph.trim() !== "")
        .map((paragraph, index) => (
        <p key={index} className="mb-4">
            {paragraph.trim()}
        </p>
    ));
}

const DisclaimerContent = ({isPopupVersion = false}) => {
    const formattedEffectiveDate = "2026-April-29";
    const lastUpdatedDate = "2026-April-29";

    const subHeading = "uppercase mb-4 font-bold"

    return (
        <div className="flex flex-col items-center flex-1 w-full min-h-0 my-4">
            <div
                id='term-container'
                className={`flex flex-col w-full h-full min-h-0 ${isPopupVersion ? "" : "border border-gray-100 rounded-md"}`}
            >
                {!isPopupVersion && (
                    <div
                        id='term-header'
                        className="w-full p-4 mx-auto text-teal-300 border-b border-gray-200 rounded-t-lg 2xl:p-6 bg-gray-20"
                        style={{ backgroundImage: `url(/images/form-header-blue.png)` }}
                    >
                        <h2 className="text-[30px] font-semibold text-center">Disclaimer</h2>
                    </div>
                )}
                <div 
                    id='term-content' 
                    className={`flex-1 min-h-0 ${isPopupVersion ? "" : "px-24 py-6"} ${isPopupVersion ? "" : "overflow-y-auto"}`}
                >
                    <div className={`max-w-5xl mx-auto ${isPopupVersion ? "" : ""}`}>
                        <div className="flex justify-end">
                            <div className="flex flex-col items-start text-teal-600 text-md w-fit">
                                <p className="flex items-center gap-1">
                                    <span className="font-bold w-[120px] text-left">Effective Date :</span>
                                    <span>{formattedEffectiveDate}</span>
                                </p>
                                <p className="mb-2 flex items-center gap-0">
                                    <span className="font-bold w-[114px] text-left">Last Updated</span>
                                    <span className="font-bold">:</span> <span className="pl-1">{lastUpdatedDate}</span>
                                </p>
                            </div>
                        </div>
                        <div className="my-2 border-b border-b-gray-100"/>

                        <h4 className={subHeading}>Disclaimer for Reel Outline</h4>
                        {formatTextToParagraphs(`
                        Healthcompass Rx is a software solution provided by Reel Outline.

                        Healthcompass Rx is a web based clinical decision support tool for pharmacist to facilitate clinical services such as minor ailment prescribing and medication reviews. Health compass Rx is not a Health Service provider.

                        While Healthcompass Rx provides valuable insights, it should not be considered a substitute for professional judgment or clinical expertise. Healthcare professionals are encouraged to use their discretion and consider individual patient needs, medical history, and other relevant factors when making healthcare decisions.

                        Healthcompass Rx is intended to support, not replace, clinical evaluation, and its recommendations should be interpreted and applied in the context of the healthcare provider's training, experience, and patient-specific circumstances. The software's accuracy, completeness, and timeliness depend on the data provided and may not account for all variables in each clinical scenario.

                        By using Healthcompass Rx, healthcare professionals acknowledge that they are responsible for the final clinical decisions and ensuring that all actions taken align with established medical standards and regulations. The creators of Healthcompass Rx disclaim any liability for any consequences resulting from the use or misuse of the software, including any errors or omissions in the recommendations provided.
                        
                        Always consult with relevant medical experts or refer to trusted sources when uncertain about any aspect of patient care.`)}
                        
                        <img
                            src="/icons/logos/reel-outline-logo-large.svg"
                            alt="REEL"
                            className="mx-auto mt-8"
                        />
                    </div>
                </div>

            </div>
        </div>
    );
}
export default DisclaimerContent;